import {TextField, type TextFieldProps} from '@mui/material';
import {forwardRef} from 'react';

const GenericTextField = forwardRef((props: TextFieldProps & {fullWidth?: boolean}, ref) => {
  const fullWidth = props.fullWidth ?? true; // backcompatibility
  const {InputLabelProps, ...originalProps} = props;
  const testFieldProps: any = {
    variant: 'outlined',
    color: 'primary',
    InputLabelProps: {
      shrink: props.InputProps?.inputComponent ? true : undefined,
      ...InputLabelProps,
    },
    ...originalProps,
  };

  return (
    <TextField
      ref={ref}
      {...testFieldProps}
      sx={{...testFieldProps.sx, width: fullWidth ? '100%' : testFieldProps.sx?.width}}
    />
  );
});

export default GenericTextField;
